import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { Turbine } from "../interfaces/turbines/turbine.interface";
import {
  LkpCountry,
  LkpCvxCriticalityRanking,
} from "../interfaces/turbines/lookup.interface";

@Injectable({
  providedIn: "root",
})
export class TurbineService {
  private readonly apiUrl = `${environment.apiUrl}/turbines`;

  constructor(private http: HttpClient) {}

  /**
   * Get all turbines
   */
  getTurbines(): Observable<Turbine[]> {
    return this.http.get<Turbine[]>(this.apiUrl);
  }

  /**
   * Get a specific turbine by ID
   */
  getTurbine(id: number): Observable<Turbine> {
    return this.http.get<Turbine>(`${this.apiUrl}/${id}`);
  }

  /**
   * Get turbines by plant ID
   */
  getTurbinesByPlant(plantId: number): Observable<Turbine[]> {
    return this.http.get<Turbine[]>(`${this.apiUrl}/plant/${plantId}`);
  }

  /**
   * Search turbines with optional query parameters
   */
  searchTurbines(params?: any): Observable<Turbine[]> {
    return this.http.get<Turbine[]>(this.apiUrl, { params });
  }

  /**
   * Create a new turbine
   */
  createTurbine(turbine: Turbine): Observable<Turbine> {
    return this.http.post<Turbine>(this.apiUrl, turbine);
  }

  /**
   * Update an existing turbine
   */
  updateTurbine(id: number, turbine: Turbine): Observable<Turbine> {
    return this.http.put<Turbine>(`${this.apiUrl}/${id}`, turbine);
  }
  /**
   * Delete a turbine
   */
  deleteTurbine(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  /**
   * Get all countries
   */
  getCountries(): Observable<LkpCountry[]> {
    return this.http.get<LkpCountry[]>(`${this.apiUrl}/countries`);
  }

  /**
   * Get CVX criticality rankings
   */
  getCvxCriticalityRankings(): Observable<LkpCvxCriticalityRanking[]> {
    return this.http.get<LkpCvxCriticalityRanking[]>(
      `${this.apiUrl}/cvx-criticality-rankings`
    );
  }

  /**
   * Bulk upload turbines from Excel file
   */
  bulkUploadTurbines(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<any>(`${this.apiUrl}/bulk-upload`, formData, {
      reportProgress: true,
      observe: 'body'
    });
  }
}
